// extracted by mini-css-extract-plugin
var _1 = "TextCard-module_text_card_danger__bWgO4z";
var _2 = "TextCard-module_text_card_default__q_P43X";
var _3 = "TextCard-module_text_card_default_with_label_border__fuKbzz";
var _4 = "TextCard-module_text_card_label__B57u78";
var _5 = "TextCard-module_text_card_primary__kVYt47";
export { _1 as "text_card_danger", _2 as "text_card_default", _3 as "text_card_default_with_label_border", _4 as "text_card_label", _5 as "text_card_primary" }
